<router-outlet></router-outlet><ngx-spinner type="eden-box" size="medium" color="#fefefe"></ngx-spinner>